import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const FormSkeleton = ({fields = 3}) => {
  return (
    <div>
      {Array(fields).fill().map((_, index) => (
        <div key={index} className="mb-3">
          <Skeleton width={150} height={20} className="mb-2"/>
          <Skeleton height={40}/>
        </div>
      ))}
    </div>
  );
};

export default FormSkeleton;
